export default {
  'emailTemplate.title': 'Email Templates',
  'emailTemplate.form.keyword': 'Keyword',
  'emailTemplate.form.keyword.placeholder': 'Search name / key / locale',
  'emailTemplate.form.merchant': 'Merchant filter',
  'emailTemplate.form.merchant.placeholder': 'All merchants',
  'emailTemplate.form.search': 'Search',
  'emailTemplate.form.reset': 'Reset',
  'emailTemplate.operation.add': 'New template',
  'emailTemplate.operation.refresh': 'Refresh',
  'emailTemplate.alert.merchantRequired':
    'Select a merchant before creating a template. The list shows all merchants.',
  'emailTemplate.columns.index': '#',
  'emailTemplate.columns.merchantName': 'Merchant',
  'emailTemplate.columns.name': 'Name',
  'emailTemplate.columns.locale': 'Locale',
  'emailTemplate.columns.source': 'Source',
  'emailTemplate.columns.enabled': 'Enabled',
  'emailTemplate.columns.createdAt': 'Created at',
  'emailTemplate.columns.updatedAt': 'Updated at',
  'emailTemplate.columns.operations': 'Actions',
  'emailTemplate.columns.operations.edit': 'Edit',
  'emailTemplate.columns.operations.preview': 'Preview',
  'emailTemplate.columns.operations.copy': 'Copy & translate',
  'emailTemplate.columns.operations.delete': 'Delete',
  'emailTemplate.columns.operations.deleteConfirm':
    'Delete template "{name}"?',
  'emailTemplate.columns.operations.deleteDisabled':
    'Built-in default template cannot be deleted',
  'emailTemplate.source.builtin': 'Built-in',
  'emailTemplate.source.custom': 'Custom',
  'emailTemplate.enabled.yes': 'On',
  'emailTemplate.enabled.no': 'Off',
  'emailTemplate.editor.back': 'Back to list',
  'emailTemplate.editor.createTitle': 'New email template',
  'emailTemplate.editor.editTitle': 'Edit template',
  'emailTemplate.editor.defaultSubject': 'Default subject',
  'emailTemplate.editor.hint':
    'Fill in the form on the left to see a live preview on the right',
  'emailTemplate.editor.panel.edit': 'Edit',
  'emailTemplate.editor.panel.preview': 'Preview',
  'emailTemplate.editor.previewLoading': 'Preview (loading…)',
  'emailTemplate.editor.templateKey': 'Template key',
  'emailTemplate.editor.templateKey.placeholder': 'e.g. order_paid_notice',
  'emailTemplate.editor.name': 'Display name',
  'emailTemplate.editor.engine': 'Engine',
  'emailTemplate.editor.enabled': 'Enabled',
  'emailTemplate.editor.subject': 'Subject',
  'emailTemplate.editor.htmlBody': 'HTML body',
  'emailTemplate.editor.remark': 'Remark (optional)',
  'emailTemplate.editor.restore': 'Restore default',
  'emailTemplate.editor.save': 'Save',
  'emailTemplate.editor.create': 'Create',
  'emailTemplate.editor.restoreConfirm':
    'This will overwrite subject and body and cannot be undone. Continue?',
  'emailTemplate.editor.restoreOk': 'Restore',
  'emailTemplate.editor.restoreCancel': 'Cancel',
  'emailTemplate.editor.previewEmpty':
    'Enter subject and HTML body on the left to preview',
  'emailTemplate.editor.previewErrors': 'Render notes',
  'emailTemplate.copy.title': 'Copy & translate template',
  'emailTemplate.copy.hint':
    'AI translates the template into the target locale and creates a new record (same templateKey).',
  'emailTemplate.copy.source': 'Source',
  'emailTemplate.copy.targetLocale': 'Target locale',
  'emailTemplate.copy.targetLocale.placeholder': 'Select target locale',
  'emailTemplate.copy.confirm': 'Translate & copy',
  'emailTemplate.copy.cancel': 'Cancel',
  'emailTemplate.preview.title': 'Email preview',
  'emailTemplate.preview.renderedSubject': 'Rendered subject',
  'emailTemplate.preview.empty': 'No preview content',
  'emailTemplate.preview.hint': 'Rendered with sample variables for layout reference only.',
  'emailTemplate.preview.close': 'Close',
  'emailTemplate.preview.goEdit': 'Edit',
  'emailTemplate.message.fetchFailed': 'Failed to load templates',
  'emailTemplate.message.saveFailed': 'Save failed',
  'emailTemplate.message.nameRequired': 'Please enter template name',
  'emailTemplate.message.subjectRequired': 'Please enter subject',
  'emailTemplate.message.htmlRequired': 'Please enter HTML body',
  'emailTemplate.message.keyRequired': 'Please enter template key',
  'emailTemplate.message.keyInvalid':
    'Template key allows lowercase letters, digits, and underscores only',
  'emailTemplate.message.copyLocaleRequired': 'Please select target locale',
  'emailTemplate.message.copyHtmlEmpty': 'Source HTML is empty',
  'emailTemplate.message.copyFailed': 'Copy & translate failed',
  'emailTemplate.message.previewFailed': 'Preview failed',
  'emailTemplate.message.createSuccess': 'Created',
  'emailTemplate.message.updateSuccess': 'Saved',
  'emailTemplate.message.deleteSuccess': 'Deleted',
  'emailTemplate.message.restoreSuccess': 'Restored to default',
};
